import { Cartesian3, Cesium3DTileStyle, Color, defined, JulianDate, ScreenSpaceEventHandler, ScreenSpaceEventType, Viewer } from "cesium";
import { createUUID, getColorFromLocalStorage, restoreSavedView, saveCurrentView } from "../../utils/utils";

import { getMessage } from "../../language";
import '../../styles/ultils.css'
import '../../styles/issuePoint/issuePoint.css'
import { DialogGeneral } from "../../utils/Dialog/dialog";

import { IconCreateElement, IconCursorRemove, IconEyeHide, IconEyeShow, IconTrash } from "../../icon";
import { DialogService, ETypeDialogService } from "../Dialog/serviceDialog";
import { ContextMenu } from "../contextMenu";

export enum EActionIssuePoint {
    ValidationSize = "Validate Size",
    ValidationColor = "Validate Color",
    ActiveCreateBtn = "Create Button",
    ActiveEditBtn = "Edit Button",
    ShowBtn = "Show Button",
    HideBtn = "Hide Button",
    RemoveAllBtn = "Remove All Button",
    RemovedAll = "Removed All",
    ClickedPoint = "Clicked Point",
    ClickedRemove = "Clicked Remove",
    EscCreate = "Esc Create",
    EscRemove = "Esc Remove"
}

interface IPointIssue {
    idEntity: string;
    pointEntity: any;
    color: string;
    size: number;
    cameraView: string;
    imgBase64: any;
    condition?: ICondition

}

interface ICondition {

    conditionColor?: [string, string]
    conditionShow?: [string, string]
}

export interface IObjIssue {
    id: string
    position: {
        x: number
        y: number
        z: number
    }
    color: string
    size: number
    cameraView: string
    imgBase64: any
    condition?: ICondition
}


export class IssuePoint {
    viewer: Viewer;
    containerId: string;
    private _IdGenneral = createUUID();//Tạo ID ngẫu nhiên khi khởi tạ
    modal: any
    private dialog: DialogGeneral | undefined;
    private _hexColor = getColorFromLocalStorage()
    private _valueSizePoint = 20
    private _containerView
    private _contextMenu: ContextMenu
    // Lưu trữ tham chiếu đến hàm xử lý sự kiện
    private _handleMouseMoveBound: (e: MouseEvent) => void;
    callback: ((data: any) => void) | undefined; // Callback từ Next.js
    // Thuộc tính để lưu callback
    private onClosedCallback: ((status: boolean) => void) | undefined;


    constructor(containerId: string, viewer: Viewer, contextMenu?: ContextMenu) {
        this._contextMenu = contextMenu!
        this._handleMouseMoveBound = (e: MouseEvent) => this._handleMouseMove(e);
        this.containerId = containerId; // Gán giá trị containerId    
        this._containerView = document.getElementById(containerId)
        this.viewer = viewer;//Gán giá trị viewer
        this.createModalIssuePoint()
        this._actionHandle()

        this.dialog?.showModal(false)



    }

    // Gán callback từ lớp cha
    setClosedCallback(callback: (status: boolean) => void): void {
        this.onClosedCallback = callback;
    }
    // Gọi callback để thông báo thay đổi trạng thái
    notifyCallBack(status: boolean): void {
        if (this.onClosedCallback) {
            this.onClosedCallback(status); // Thông báo cho lớp cha
            if (!status) {
                // console.log("zxczxc");
                // this.removeAllClickEvents();
                this.triggerChange({
                    status: status,
                    action: "Closed"
                })
            }
        } else {
            console.error("State change callback is not set.");
        }
    }
    //#region triggerChange
    triggerChange = (data: any) => {
        // console.log("Gọi callback với data:", data);
        if (this.callback) {
            this.callback(data); // Gọi callback khi có thay đổi
        }
    };

    createModalIssuePoint = () => {
        this.dialog = new DialogGeneral(
            this.containerId,
            this.handleCloseModal
        );
        this.dialog.innerHeader = "Issues";
        this.dialog.modal = false
        this.dialog.minimizeDialog = true;
        this.dialog.widthModal = "250px"
        this.dialog.heightModal = "180px"
        this.dialog.minHeightModal = 180
        this.dialog.minWidthModal = 175
        this.dialog.innerBody = this._renderIssuePointData()
        this.dialog.createDialog();
        // this._createCanvasMarkup()

    }



    showHideModalIssuePoint = (show: boolean) => {

        if (show) {
            this.showHideAllIssuePoint(true)
            this._activeHandleFormMouse()
            this._createToolTipMouse()
            document.addEventListener("keydown", this._handleKeyboard)

        } else {
            // this.removeAllClickEvents();
            this._resetPoint()
            this._removeHandleFromMouse()
            this._removeTooltipMouse()
            document.removeEventListener("keydown", this._handleKeyboard)
            this._removeActionFromBtn()
            this.showHideAllIssuePoint(false)

        }
        this.dialog?.showModal(show)


    }

    private handleCloseModal = (status: boolean) => {
        if (!status) {
            this.notifyCallBack(status)

        }
    }
    private containerDiv: HTMLDivElement | undefined
    //#region  render markup table
    private _renderIssuePointData = () => {
        if (this.containerDiv) {
            this.clearContainer()
        } else {
            this.containerDiv = document.createElement('div')
            this.containerDiv.className = 'container-tab-issue-point';
            this.containerDiv.innerHTML = `
                <label>${getMessage("issue-point-size-point")}:</label>              
                <input class="dpu-input-text" type="number" value="${this._valueSizePoint}" id="issue-size-point-${this._IdGenneral}" style="margin-bottom: 5px;">
            
                <label>${getMessage("issue-point-color-point")}:</label>
                <input  class="input-form-label dpu-inpu-color"  id="issue-point-color-${this._IdGenneral}" value = "${this._hexColor}" type="color"/>

                <div id="DPU-container-group-btn-iusse-${this._IdGenneral}" class="DPU-container-group-btn-iusse">
                    <div id="issue-create-point-${this._IdGenneral}" class ="DPU-btn-defaut-style">
                        ${IconCreateElement()}
                    </div>
                    <div id="issue-click-point-remove-${this._IdGenneral}" class ="DPU-btn-defaut-style">
                        ${IconCursorRemove()}
                    </div>
                    <div id="issue-show-point-${this._IdGenneral}" class ="DPU-btn-defaut-style" style="display:none">
                        ${IconEyeShow()}
                    </div>
                    <div id="issue-hide-point-${this._IdGenneral}" class ="DPU-btn-defaut-style">
                        ${IconEyeHide()}
                    </div>
                    <div id="issue-remove-all-point-${this._IdGenneral}" class ="DPU-btn-defaut-style">
                        ${IconTrash()}
                    </div>
                </div>

                `
        }




        return this.containerDiv
    }

    private clearContainer = () => {
        if (this.containerDiv) {
            while (this.containerDiv.firstChild) {
                this.containerDiv.removeChild(this.containerDiv.firstChild);
            }
        }
    }

    private _inputPointSize: any
    private _inputPointColor: any
    //#region _actionHandle
    private _actionHandle = () => {
        const btnClickCreate = document.querySelector(`#issue-create-point-${this._IdGenneral}`) as HTMLElement
        btnClickCreate?.addEventListener('click', () => { this._actionBtn(`issue-create-point-${this._IdGenneral}`) })

        const btnClickRemove = document.querySelector(`#issue-click-point-remove-${this._IdGenneral}`) as HTMLElement
        btnClickRemove?.addEventListener('click', () => { this._actionBtn(`issue-click-point-remove-${this._IdGenneral}`) })


        const btnClickShow = document.querySelector(`#issue-show-point-${this._IdGenneral}`) as HTMLElement
        btnClickShow?.addEventListener('click', () => {
            this._actionBtn(`issue-show-point-${this._IdGenneral}`)
        })

        const btnClickHide = document.querySelector(`#issue-hide-point-${this._IdGenneral}`) as HTMLElement
        btnClickHide?.addEventListener('click', () => {
            this._actionBtn(`issue-hide-point-${this._IdGenneral}`)
        })

        const btnRemoveAll = document.querySelector(`#issue-remove-all-point-${this._IdGenneral}`) as HTMLElement
        btnRemoveAll?.addEventListener('click', () => {
            this._actionBtn(`issue-remove-all-point-${this._IdGenneral}`)
        })

        //Input size
        this._inputPointSize = document.querySelector(`#issue-size-point-${this._IdGenneral}`)
        this._inputPointSize!.addEventListener('input', (event: Event) => {
            const target = event.target as HTMLInputElement;
            this._valueSizePoint = Number(target.value)

            // Kiểm tra giá trị hợp lệ
            if (isNaN(this._valueSizePoint) || this._valueSizePoint <= 0) {
                this._valueSizePoint = 1; // Gán giá trị mặc định nếu không hợp lệ
            }
            this._inputPointSize.value = this._valueSizePoint

            if (this._isEdit) {
                this._listPointIssue[this._activeEntityPoint.id].size = this._inputPointSize.value
                this._activeEntityPoint.point.pixelSize = Number(this._inputPointSize.value)
                // this._lastSizePickPoint = Number(this._inputPointSize.value)
                //gọi ra callback

                this.triggerChange({
                    action: EActionIssuePoint.ValidationSize,
                    status: true,
                    dataPoint: this._listPointIssue[this._activeEntityPoint.id]
                })
                this.viewer.scene.requestRender()

            } else {
                //gọi ra callback

                this.triggerChange({
                    action: EActionIssuePoint.ValidationSize,
                    status: false,
                    data: Number(target.value)
                })
            }
        })

        //Input color
        //Input size
        this._inputPointColor = document.querySelector(`#issue-point-color-${this._IdGenneral}`)
        this._inputPointColor!.addEventListener("input", (event: Event) => {
            const input = event.target as HTMLInputElement;
            const colorValue = input.value.trim();
            this._hexColor = colorValue
            // Lưu mã màu hợp lệ xuống localStorage
            localStorage.setItem("selectedColor", colorValue);

            if (this._isEdit) {
                this._listPointIssue[this._activeEntityPoint.id].color = this._hexColor
                this._activeEntityPoint.point.color = Color.fromCssColorString(this._hexColor)
                //gọi ra callback
                this.triggerChange({
                    action: EActionIssuePoint.ValidationColor,
                    status: true,
                    dataPoint: this._listPointIssue[this._activeEntityPoint.id]
                })
                this.viewer.scene.requestRender()

            } else {
                //gọi ra callback
                this.triggerChange({
                    action: EActionIssuePoint.ValidationColor,
                    status: false,
                    data: input.value.trim()
                })
            }
        })

        this._activeHandleFormMouse()
    }
    //#region _actionRemoveByClick
    private _actionRemoveByClick = () => {
        this._removeHandleFromMouse()


        this._containerView?.addEventListener("mousemove", this._handleMouseMoveBound)
        this._toolTip!.textContent = getMessage("issue-point-tool-tip-remove"); // Nội dung tooltip

        this._handleMouse?.setInputAction(async (click: ScreenSpaceEventHandler.PositionedEvent) => {

            let pickedObject = this.viewer.scene.pick(click.position);
            if (pickedObject?.id?.id) {
                const isIssuePoint = pickedObject.id.id.includes("issue-point-")

                if (isIssuePoint) {
                    const dialog = new DialogService({
                        containerId: this.containerId,
                        typeDialog: ETypeDialogService.Warning,
                        inputModal: {
                            contentHeader: getMessage("dialog-service-question-remove-header"),
                            contentBody: getMessage("dialog-service-question-remove-content")
                        }
                    });

                    // Chờ đợi người dùng nhấn nút OK hoặc Cancel
                    await dialog.showModalAndWait();
                    if (dialog._action === "Ok") {
                        this.triggerChange({
                            action: EActionIssuePoint.ClickedRemove,
                            status: true,
                            dataPoint: this._listPointIssue[pickedObject.id.id]
                        })
                        this.removeIssuePointById(pickedObject.id.id)
                    } else {
                        this.triggerChange({
                            action: EActionIssuePoint.ClickedRemove,
                            status: false,
                            dataPoint: this._listPointIssue[pickedObject.id.id]
                        })
                    }


                }
            }
            this.viewer.scene.requestRender()

        }, ScreenSpaceEventType.LEFT_CLICK)


    }

    //region removeIssuePointById
    removeIssuePointById = (idPoint: string) => {
        const pointEntity = this._listPointIssue[idPoint]?.pointEntity
        if (pointEntity) {
            this.viewer.entities.remove(pointEntity)
        }

        delete this._listPointIssue[idPoint]

    }
    //#region _actionCreatePoint
    private _actionCreatePoint = (btnClick: HTMLElement) => {

        if (!this._handleMouse) {
            this._handleMouse = new ScreenSpaceEventHandler(this.viewer.canvas)
        }
        // this._handleMouse?.removeInputAction(ScreenSpaceEventType.MOUSE_MOVE)
        // this._handleMouse?.removeInputAction(ScreenSpaceEventType.LEFT_DOWN)
        // this._handleMouse?.removeInputAction(ScreenSpaceEventType.LEFT_UP)
        // this._handleMouse?.removeInputAction(ScreenSpaceEventType.LEFT_CLICK)


        this._containerView!.addEventListener('mousemove', this._handleMouseMoveBound);
        this._toolTip!.textContent = getMessage("issue-point-tool-tip-create"); // Nội dung tooltip
        this._handleMouse.setInputAction((click: ScreenSpaceEventHandler.PositionedEvent) => this._handleClickCreatePoint(click, btnClick), ScreenSpaceEventType.LEFT_CLICK)


    }
    private _listPointIssue: { [entityId: string]: IPointIssue } = {}
    // private _lastSizePickPoint = 0
    //#region _handleClickCreatePoint
    private _handleMouse: ScreenSpaceEventHandler | undefined
    private _handleClickCreatePoint = (click: ScreenSpaceEventHandler.PositionedEvent, btnClick: HTMLElement) => {
        this._resetPoint()


        let cartesian = this.viewer.scene.pickPosition(click.position);
        if (cartesian) {
            // Sử dụng drillPick để kiểm tra vật thể
            let pickedObject = this.viewer.scene.drillPick(click.position);

            if (pickedObject.length == 0) {
                let ray = this.viewer.camera.getPickRay(click.position);
                cartesian = this.viewer.scene.globe.pick(ray!, this.viewer.scene) as Cartesian3;
            }
        }

        if (defined(cartesian)) {
            let entityIdBase = createUUID()


            //Ẩn hết tất cả các điểm
            this.showHideAllIssuePoint(false)
            this.viewer.scene.requestRender()
            // Tạo một point để hiển thị vị trí đã pick trên bề mặt
            let point = this.viewer.entities.add({
                id: "issue-point-" + entityIdBase, // Đảm bảo ID là duy nhất
                position: cartesian,

                point: {
                    color: Color.fromCssColorString(this._hexColor),
                    pixelSize: this._valueSizePoint as number,
                    outlineColor: Color.WHITE,
                    outlineWidth: 2,
                    disableDepthTestDistance: Number.POSITIVE_INFINITY,
                }
            });

            this.viewer.scene.requestRender()


            // Đảm bảo Cesium đã render xong rồi mới chụp ảnh
            setTimeout(() => {
                const imgBase64 = this.captureCesiumCanvas();

                this._listPointIssue["issue-point-" + entityIdBase] = {
                    idEntity: "issue-point-" + entityIdBase,
                    color: this._hexColor,
                    size: this._valueSizePoint,
                    pointEntity: point,
                    cameraView: saveCurrentView(this.viewer),
                    imgBase64: imgBase64,
                    condition: {
                        conditionColor: this._contextMenu.tempCondition.conditionColor || [],
                        conditionShow: this._contextMenu.tempCondition.conditionShow || []
                    }
                };

                this.triggerChange({
                    action: 'Created Point',
                    dataPoint: this._listPointIssue["issue-point-" + entityIdBase]
                });
            }, 50); // delay để đảm bảo canvas được render xong


        }
        // console.log(this._contextMenu.tempCondition);
        // Nếu tooltip đã hiển thị và người dùng tiếp tục di chuyển chuột, ẩn tooltip
        this._removeActionToolTip()
        //Hủy khi pick xong 

        this._handleMouse?.removeInputAction(ScreenSpaceEventType.LEFT_CLICK)



        btnClick.classList.remove("active")
        this._activeHandleFormMouse()
        this._refreshDisableBtn()
        this.viewer.scene.requestRender()
    }

    // #region _clickCheckPointIssue

    private _clickCheckPointIssue = (click: ScreenSpaceEventHandler.PositionedEvent) => {
        // Lấy tất cả các primitives trong scene

        let pickedObject = this.viewer.scene.pick(click.position);
        if (pickedObject?.id?.id) {
            const isIssuePoint = pickedObject.id.id.includes("issue-point-")
            if (isIssuePoint && pickedObject.id.id !== this._activeEntityPoint?.id) {
                if (this._activeEntityPoint) {
                    // this._activeEntityPoint.point.pixelSize = this._lastSizePickPoint as number

                }

                this._activeEntityPoint = pickedObject.id
                restoreSavedView(this.viewer, this._listPointIssue[this._activeEntityPoint.id].cameraView)
                this._restorDataForEdit(this._activeEntityPoint.id)
                this.triggerChange({
                    action: EActionIssuePoint.ClickedPoint,
                    dataPoint: this._listPointIssue[pickedObject.id.id]
                })
                this._refreshConditionIssuePoint(pickedObject.id.id)
                // this._lastSizePickPoint = (this._activeEntityPoint.point.pixelSize as any)['_value']
                // console.log("this._lastSizePickPoint", this._lastSizePickPoint);
                // this._activeEntityPoint.point.pixelSize = this._lastSizePickPoint as number + 5
                // this._handleMouse?.removeInputAction(ScreenSpaceEventType.LEFT_CLICK)
            }
        } else {
            this._resetPoint()
            this.triggerChange({
                action: EActionIssuePoint.ClickedPoint,
                dataPoint: undefined
            })
        }
    }

    private _isDragging = false
    //#region _createMouseMouve
    private _createMouseMove = (movement: ScreenSpaceEventHandler.MotionEvent) => {

        if (this._isDragging) {
            let cartesian = this.viewer.scene.pickPosition(movement.endPosition);
            if (defined(cartesian)) {
                this._activeEntityPoint.position = cartesian
            }
            this.viewer.scene.requestRender()

        }

    }
    private _activeEntityPoint: any

    //#region _createMouseLeftDown
    private _createMouseLeftDown = (click: ScreenSpaceEventHandler.PositionedEvent) => {
        let pickedObject = this.viewer.scene.pick(click.position);
        if (pickedObject?.id?.id) {
            const isIssuePoint = pickedObject.id.id.includes(this._activeEntityPoint?.id)
            if (isIssuePoint) {
                this._isDragging = true

                this.viewer.scene.screenSpaceCameraController.enableRotate = false;  // Tắt xoay
                this.viewer.scene.screenSpaceCameraController.enableTilt = false;    // Tắt nghiêng
                this.viewer.scene.screenSpaceCameraController.enableLook = false;
            }
        }
        this.viewer.scene.requestRender()

    }


    //#region _createMouseLeftUp
    private _createMouseLeftUp = (click: ScreenSpaceEventHandler.PositionedEvent) => {
        if (this._isDragging) {


            this._isDragging = false
            this.viewer.scene.screenSpaceCameraController.enableRotate = true;  // Tắt xoay
            this.viewer.scene.screenSpaceCameraController.enableTilt = true;    // Tắt nghiêng
            this.viewer.scene.screenSpaceCameraController.enableLook = true;


            this._listPointIssue[this._activeEntityPoint.id].cameraView = saveCurrentView(this.viewer)
            this._listPointIssue[this._activeEntityPoint.id].condition = {
                conditionColor: this._contextMenu.tempCondition.conditionColor || [],
                conditionShow: this._contextMenu.tempCondition.conditionShow || [],
            }
            this.showHideAllIssuePoint(false)
            this._activeEntityPoint.show = true
            this.viewer.scene.requestRender()

            setTimeout(() => {

                this._listPointIssue[this._activeEntityPoint.id].imgBase64 = this.captureCesiumCanvas()

            }, 50)

        }
        this.viewer.scene.requestRender()

    }

    //#region _resetPoint
    private _resetPoint = () => {
        if (this._activeEntityPoint) {
            // this._activeEntityPoint.point.pixelSize = this._lastSizePickPoint as number
            this._activeEntityPoint = undefined
            // this._lastSizePickPoint = 0
            this._isEdit = false
        }

    }
    //#region _activeHandleFormMouse
    private _activeHandleFormMouse = () => {
        this._handleMouse?.setInputAction((movement: ScreenSpaceEventHandler.MotionEvent) => this._createMouseMove(movement), ScreenSpaceEventType.MOUSE_MOVE)
        this._handleMouse?.setInputAction((click: ScreenSpaceEventHandler.PositionedEvent) => this._createMouseLeftDown(click), ScreenSpaceEventType.LEFT_DOWN)
        this._handleMouse?.setInputAction((click: ScreenSpaceEventHandler.PositionedEvent) => this._createMouseLeftUp(click), ScreenSpaceEventType.LEFT_UP)
        this._handleMouse?.setInputAction((click: ScreenSpaceEventHandler.PositionedEvent) => this._clickCheckPointIssue(click), ScreenSpaceEventType.LEFT_CLICK)
    }
    //#region _removeHandleFromMouse
    private _removeHandleFromMouse = () => {
        this._handleMouse?.removeInputAction(ScreenSpaceEventType.MOUSE_MOVE)
        this._handleMouse?.removeInputAction(ScreenSpaceEventType.LEFT_DOWN)
        this._handleMouse?.removeInputAction(ScreenSpaceEventType.LEFT_UP)
        this._handleMouse?.removeInputAction(ScreenSpaceEventType.LEFT_CLICK)



        this._removeActionToolTip()


    }

    private _removeActionFromBtn = () => {
        const containerView = document.getElementById(`${this.containerId}`)
        const groupBtn = containerView?.querySelector(`#DPU-container-group-btn-iusse-${this._IdGenneral}`)
        const btnCreate = groupBtn?.querySelector(`#issue-create-point-${this._IdGenneral}`)
        const btnRemove = groupBtn?.querySelector(`#issue-click-point-remove-${this._IdGenneral}`)
        const activeCreate = btnCreate?.className.includes("active")
        const activeRemove = btnRemove?.className.includes("active")
        if (activeCreate) {
            this.triggerChange({
                action: EActionIssuePoint.EscCreate
            })
        } else if (activeRemove) {
            this.triggerChange({
                action: EActionIssuePoint.EscRemove
            })
        }
        if (activeCreate || activeRemove) {
            this._removeActionToolTip()
            const listBtn = groupBtn?.querySelectorAll(`.DPU-btn-defaut-style`)
            listBtn?.forEach(btn => {
                btn.classList.remove("active")
                btn.classList.remove("disabled")
            })

        }
    }

    //#region _restorDataForEdit
    private _isEdit = false
    private _restorDataForEdit = (idEntityBase: string) => {
        const sizePoint = this._listPointIssue[idEntityBase].size
        const pointColor = this._listPointIssue[idEntityBase].color
        this._inputPointSize.value = sizePoint
        this._valueSizePoint = Number(sizePoint)
        this._inputPointColor.value = pointColor
        this._hexColor = pointColor
        this._isEdit = true
    }

    //#region showHideAllIssuePoint
    showHideAllIssuePoint = (show: boolean) => {
        this._handleBtnForShowHideBtn(show)
        // Duyệt qua danh sách để tìm và xóa 
        Object.keys(this._listPointIssue).forEach(key => {
            const entityPoint = this._listPointIssue[key].pointEntity;
            entityPoint.show = show
        });
        this.viewer.scene.requestRender()

    }
    //#region showHideAllIssuePoint
    removeAllIssuePoint = () => {

        // Duyệt qua danh sách để tìm và xóa 
        Object.keys(this._listPointIssue).forEach(key => {
            this.removeIssuePointById(key)
        });
        this.viewer.scene.requestRender()

    }

    //#region _actionBtn



    private _actionBtn = async (idBtnHtml: string) => {
        const btnIdHtml = document.querySelector(`#${idBtnHtml}`)
        switch (idBtnHtml) {
            case `issue-create-point-${this._IdGenneral}`:

                const listDisableCreate = [
                    `issue-click-point-remove-${this._IdGenneral}`,
                    `issue-show-point-${this._IdGenneral}`,
                    `issue-hide-point-${this._IdGenneral}`,
                    `issue-remove-all-point-${this._IdGenneral}`,
                ]
                this._handleBtnForShowHideBtn(true)

                this.showHideAllIssuePoint(true)

                if (btnIdHtml?.className.includes("active")) {
                    this._activeBtn(`issue-create-point-${this._IdGenneral}`, false)
                    //bật listh BTN
                    this._disableBtnByList(listDisableCreate, false)

                    this.triggerChange({
                        action: EActionIssuePoint.ActiveCreateBtn,
                        status: false
                    })
                    this._removeHandleFromMouse();
                    this._activeHandleFormMouse()
                } else {

                    //disable listh BTN
                    this._disableBtnByList(listDisableCreate, true)
                    this._disableBtn(`issue-create-point-${this._IdGenneral}`, false)

                    //activeBtn
                    this.triggerChange({
                        action: EActionIssuePoint.ActiveCreateBtn,
                        status: true
                    })
                    this._activeBtn(`issue-create-point-${this._IdGenneral}`, true)
                    // this._removeHandleFromMouse();
                    this._actionCreatePoint(btnIdHtml! as HTMLElement)
                }


                break;
            case `issue-click-point-remove-${this._IdGenneral}`:

                const listDisableRemoveClick = [
                    `issue-create-point-${this._IdGenneral}`,
                    `issue-show-point-${this._IdGenneral}`,
                    `issue-hide-point-${this._IdGenneral}`,
                    `issue-remove-all-point-${this._IdGenneral}`,
                ]
                // this._handleBtnForShowHideBtn(true)

                this.showHideAllIssuePoint(true)


                if (btnIdHtml?.className.includes("active")) {
                    this.triggerChange({
                        action: 'Remove Button',
                        status: false
                    })
                    this._activeBtn(`issue-click-point-remove-${this._IdGenneral}`, false)
                    //bật listh BTN
                    this._disableBtnByList(listDisableRemoveClick, false)
                    this._removeHandleFromMouse()
                    this._activeHandleFormMouse()

                } else {
                    this.triggerChange({
                        action: 'Remove Button',
                        status: true
                    })
                    //disable listh BTN
                    this._disableBtnByList(listDisableRemoveClick, true)
                    this._disableBtn(`issue-click-point-remove-${this._IdGenneral}`, false)

                    //activeBtn
                    this._activeBtn(`issue-click-point-remove-${this._IdGenneral}`, true)
                    // this._removeHandleFromMouse();
                    this._actionRemoveByClick()
                }

                break

            case `issue-show-point-${this._IdGenneral}`:
                // this._handleBtnForShowHideBtn(true)
                this.showHideAllIssuePoint(true)
                this.triggerChange({ action: EActionIssuePoint.ShowBtn })

                break

            case `issue-hide-point-${this._IdGenneral}`:
                this._handleBtnForShowHideBtn(false)
                this.showHideAllIssuePoint(false)
                this.triggerChange({ action: EActionIssuePoint.HideBtn })

                break

            case `issue-remove-all-point-${this._IdGenneral}`:
                this.triggerChange({ action: EActionIssuePoint.RemoveAllBtn })

                const dialog = new DialogService({
                    containerId: this.containerId,
                    typeDialog: ETypeDialogService.Warning,
                    inputModal: {
                        contentHeader: getMessage("dialog-service-question-remove-header"),
                        contentBody: getMessage("dialog-service-question-remove-all")
                    }
                });

                // Chờ đợi người dùng nhấn nút OK hoặc Cancel
                await dialog.showModalAndWait();
                if (dialog._action === "Ok") {
                    this.removeAllIssuePoint()
                    this.triggerChange({
                        action: EActionIssuePoint.RemovedAll,
                    })

                }

                break
            default:
                break;
        }

    }
    //#region handleBtnForShowHideBtn
    private _handleBtnForShowHideBtn = (show: boolean) => {
        const btnShow = document.querySelector(`#issue-show-point-${this._IdGenneral}`) as HTMLElement;
        const btnHide = document.querySelector(`#issue-hide-point-${this._IdGenneral}`) as HTMLElement;

        if (!show) {
            btnShow!.style.display = '';
            btnHide!.style.display = "none";

        } else {
            btnShow!.style.display = 'none';
            btnHide!.style.display = "";
        }

    }
    //#region _activeBtn
    private _activeBtn = (idElement: string, active: boolean) => {
        const containerView = document.getElementById(`${this.containerId}`)
        const groupBtn = containerView?.querySelector(`#DPU-container-group-btn-iusse-${this._IdGenneral}`)
        const btn = groupBtn?.querySelector(`#${idElement}`)
        if (active) {
            btn!.classList.add("active")
        } else {
            btn!.classList.remove("active")

        }
    }

    //#region _disableBtn
    private _disableBtn = (idElement: string, disable: boolean) => {
        const containerView = document.getElementById(`${this.containerId}`)
        const groupBtn = containerView?.querySelector(`#DPU-container-group-btn-iusse-${this._IdGenneral}`)
        const btn = groupBtn?.querySelector(`#${idElement}`)
        if (disable) {
            btn!.classList.add("disabled")
        } else {
            btn!.classList.remove("disabled")

        }
    }


    //#region _disableBtnByList
    private _disableBtnByList = (listIdBtn: string[], disable: boolean) => {
        listIdBtn.forEach(idBtn => {
            this._disableBtn(idBtn, disable)
        })
    }
    //#region _refreshDisableBtn
    private _refreshDisableBtn = () => {
        const containerView = document.getElementById(`${this.containerId}`)
        const groupBtn = containerView?.querySelector(`#DPU-container-group-btn-iusse-${this._IdGenneral}`)
        const listBtn = groupBtn?.querySelectorAll(`.DPU-btn-defaut-style`)

        listBtn!.forEach(element => {
            element.classList.remove('disabled')
        });
    }

    //#region _handleKeyboard
    private _handleKeyboard = (event: KeyboardEvent) => {
        // Kiểm tra nếu phím Escape được nhấn
        if (event.key === "Escape" || event.key === "Esc") {


            this._resetPoint()
            this._removeHandleFromMouse()
            this._removeActionFromBtn()
            this._activeHandleFormMouse()
            // document.removeEventListener("keydown", this._handleKeyboard)



        }
    }

    //#region captureCesiumCanvas
    captureCesiumCanvas = () => {

        // Lấy thẻ canvas bên trong Cesium     
        const canvas = this.viewer.canvas
        // Chuyển canvas thành Data URL (hình ảnh PNG)
        // canvas.toBlob(blob => {
        //     const url = URL.createObjectURL(blob!);
        //     const newImg = document.createElement("img");
        //     console.log("url", url);
        //     console.log("blob", blob);
        //     newImg.onload = () => {
        //         // no longer need to read the blob so it's revoked
        //         URL.revokeObjectURL(url);
        //     };
        //    newImg.src = url;
        //     console.log("newImg",newImg);

        // })

        // Chuyển canvas thành Data URL (hình ảnh PNG)
        const dataURL = canvas.toDataURL("image/png");

        // // Tạo một thẻ <a> để tải hình ảnh về
        // const link = document.createElement('a');
        // link.href = dataURL;
        // link.download = 'cesium_canvas_image.png'; // Đặt tên tệp tin khi tải xuống

        // // Kích hoạt sự kiện click để tải hình ảnh về
        // link.click()
        // // Xóa thẻ <a> sau khi sử dụng
        // link.remove();
        // //Bật hết tất cả các điểm
        this.showHideAllIssuePoint(true)

        return dataURL

    }



    //#region getObjIssues
    getObjIssues = () => {
        const listObj: IObjIssue[] = []
        Object.keys(this._listPointIssue).forEach(key => {
            const position = this._listPointIssue[key].pointEntity.position.getValue(JulianDate.now());
            const obj: IObjIssue = {
                id: this._listPointIssue[key].idEntity,
                color: this._listPointIssue[key].color,
                cameraView: this._listPointIssue[key].cameraView,
                imgBase64: this._listPointIssue[key].imgBase64,
                size: this._listPointIssue[key].size,
                condition: {
                    conditionColor: this._contextMenu.tempCondition.conditionColor || [],
                    conditionShow: this._contextMenu.tempCondition.conditionShow || [],
                },
                position: position
            }
            listObj.push(obj)


        })

    }

    //#region setObjIssues
    setObjIssues = (listObj: IObjIssue[]) => {
        listObj.forEach(obj => {
            const key = this._listPointIssue[obj.id]
            if (!key) {

                const pointEntity = this.viewer.entities.add({
                    id: obj.id, // Đảm bảo ID là duy nhất
                    position: new Cartesian3(obj.position.x, obj.position.y, obj.position.z),

                    point: {
                        color: Color.fromCssColorString(obj.color),
                        pixelSize: obj.size as number,
                        outlineColor: Color.WHITE,
                        outlineWidth: 2,
                        disableDepthTestDistance: Number.POSITIVE_INFINITY,
                        show: false
                    }

                });


                const pointIssue: IPointIssue = {
                    cameraView: obj.cameraView,
                    color: obj.color,
                    idEntity: obj.id,
                    pointEntity: pointEntity,
                    imgBase64: obj.imgBase64,
                    size: obj.size,
                    condition: {
                        conditionColor: obj.condition?.conditionColor,
                        conditionShow: obj.condition?.conditionShow
                    }

                }
                this._listPointIssue[obj.id] = pointIssue
            }
        })
    }

    //#region _createToolTipMouse
    private _toolTip: HTMLElement | undefined
    private _isToolTipVisible = false; // Biến để kiểm tra trạng thái tooltip
    private _toolTipTimeout: any; // Biến để lưu timeout

    private _createToolTipMouse = () => {
        const containerId = document.querySelector(`#${this.containerId}`) as HTMLElement;
        this._toolTip = document.createElement('div');
        this._toolTip.style.display = "none"
        this._toolTip.classList.add('DPU-tooltip-mouse-move');
        this._toolTip.id = `issue-tooltip-mouse-move-${this._IdGenneral}`

        containerId?.appendChild(this._toolTip);

    }


    // #region _handleMouseMove
    // Hàm xử lý khi chuột di chuyển trên canvas

    private _handleMouseMove(event: MouseEvent) {
        if (event.target !== this.viewer.canvas) {
            // Nếu tooltip đã hiển thị và người dùng tiếp tục di chuyển chuột, ẩn tooltip
            if (this._isToolTipVisible) {
                this._hideToolTip();
            }
            if (this._toolTipTimeout) {
                clearTimeout(this._toolTipTimeout);
            }
            return
        } else {

            // Lấy tọa độ chuột trên màn hình
            const mouseX = event.clientX;
            const mouseY = event.clientY;

            // Tính toán tọa độ chuột trên canvas
            const rect = this.viewer.canvas
            const offsetX = mouseX - rect.clientLeft;
            const offsetY = mouseY - rect.clientTop;

            // Xác định vị trí của context menu
            this._toolTip!.style.left = `${offsetX}px`;
            this._toolTip!.style.top = `${offsetY}px`;


            // Gọi _resetToolTipTimeout khi chuột di chuyển để bắt đầu đếm thời gian lại
            this._resetToolTipTimeout();

            // Nếu tooltip đã hiển thị và người dùng tiếp tục di chuyển chuột, ẩn tooltip
            if (this._isToolTipVisible) {
                this._hideToolTip();
            }

            // // In ra tọa độ chuột trong canvas
            // console.log(`Mouse Position: X: ${mouseX}, Y: ${mouseY}`);
        }
    }
    //#region _removeTooltipMouse

    private _removeTooltipMouse = () => {
        if (this._toolTip && this._toolTip.parentElement) {
            this._toolTip.parentElement.removeChild(this._toolTip); // Xóa _toolTip khỏi DOM
            this._toolTip = undefined; // Đặt lại _toolTip về undefined sau khi xóa
        }
    }


    private _showToolTip = () => {
        if (this._toolTip) {
            this._toolTip.style.display = "block"; // Hiển thị tooltip
            this._isToolTipVisible = true;
        }
    };

    private _hideToolTip = () => {
        if (this._toolTip) {
            this._toolTip.style.display = "none"; // Ẩn tooltip
            this._isToolTipVisible = false;
        }
    };

    //#region _resetToolTipTimeout
    private _resetToolTipTimeout = () => {
        // Nếu đã có timeout cũ, hủy nó
        if (this._toolTipTimeout) {
            clearTimeout(this._toolTipTimeout);
        }

        // Thiết lập timeout mới để hiển thị tooltip sau 2 giây
        this._toolTipTimeout = setTimeout(() => {
            this._showToolTip(); // Hiển thị tooltip sau 2 giây
        }, 2000);
    };
    //#region _removeActionToolTip
    private _removeActionToolTip = () => {
        if (this._isToolTipVisible) {
            this._hideToolTip();
        }
        if (this._toolTipTimeout) {
            clearTimeout(this._toolTipTimeout);
        }
        this._containerView!.removeEventListener('mousemove', this._handleMouseMoveBound);
    }


    private _refreshConditionIssuePoint = (idEntity: string) => {
        const primitives = (this.viewer.scene.primitives as any)._primitives
        const condition = this._listPointIssue[idEntity].condition
        if (condition?.conditionColor || condition?.conditionShow) {
            if (primitives) {

                primitives.forEach((pri: any) => {
                    if (pri?.resource?.url) {
                        pri.style = new Cesium3DTileStyle({
                            defines: {
                                batchId: "${feature['BatchId']}",
                                fileName: "${feature['Filename']}",
                                guid: "${feature['Guid']}",
                            },
                            color: {
                                conditions: condition?.conditionColor ? condition?.conditionColor : undefined
                            },
                            show: {
                                conditions: condition?.conditionShow ? condition?.conditionShow : undefined
                            },
                        })
                        // this._listPointIssue[idEntity].primitives?.push({
                        //     url: pri?.resource.url,
                        //     conditionColor: pri?.style?.color.conditionsExpression.conditions,
                        //     conditionShow: pri?.style?.show.conditionsExpression.conditions

                        // })
                    }
                });
            }

        }

    }

    //#region action 
    createIssuePoint = (obj: IObjIssue) => {
        
    }


}